// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__3KbnO","content":"RecentSearches_content__rheL6"};